import React from "react";

import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";
import { debounce } from "utils";


import { Form, Input, SelectPicker } from "rsuite";

export default ({
    mccMncList,
    dialerList,
    defaultFilter,
    supplierList,
    onChangeFilter,
    mccMncMatchList,
    exceptionList
}) => {

    return (
        <>
            <Form
                formDefaultValue={defaultFilter}
                onChange={debounce((value) => {
                    onChangeFilter(value);
                }, 1000)}
            >
                <FlexGrid align="middle">
                    <FlexGridItem>
                        <Form.Control
                            accepter={SelectPicker}
                            cleanable
                            searchable={false}
                            data={exceptionList}
                            valueKey="value"
                            labelKey="name"
                            name="type"
                            placeholder="Type"
                            style={{ width: 130 }}
                        />
                    </FlexGridItem>

                    <FlexGridItem>
                        <Form.Control
                            accepter={SelectPicker}
                            cleanable
                            searchable
                            data={supplierList}
                            valueKey="supplier_id"
                            labelKey="name"
                            name="supplier_id"
                            placeholder="Supplier"
                            style={{ width: 240 }}
                            menuStyle={{ width: 360 }}
                        />
                    </FlexGridItem>

                    <FlexGridItem>
                        <Form.Control
                            accepter={Input}
                            name="senderid"
                            placeholder="Sender ID"
                            style={{ width: 180 }}
                        />
                    </FlexGridItem>

                    <FlexGridItem>
                        <Form.Control
                            accepter={SelectPicker}
                            data={mccMncList}
                            valueKey="mcc_mnc"
                            labelKey="nameMccMnc"
                            name="mcc_mnc"
                            placeholder="MCC/MNC"
                            style={{ width: 220 }}
                            menuStyle={{ width: 360 }}
                        />
                    </FlexGridItem>

                    <FlexGridItem>
                        <Form.Control
                            cleanable
                            name="dialer_id"
                            accepter={SelectPicker}
                            data={dialerList}
                            valueKey="id"
                            labelKey="name"
                            placeholder="Dialer"
                            style={{ width: 240 }}
                            menuStyle={{ width: 360 }}
                        />
                    </FlexGridItem>

                </FlexGrid>
            </Form>
        </>
    );
};